import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[dragDropFile]',
  standalone: false,
})
export class DragDropFileDirective {
  /** The initial background color when not dragging. Defaults to 'inherit' to use parent's background. */
  @Input('background')
  set initialBackground(value: string) {
    this._initialBackground = value;
    this._background = value;
  }
  get initialBackground(): string {
    return this._initialBackground;
  }
  private _initialBackground = 'inherit';

  /** The color the component will change to while dragging a file over it. */
  @Input() activeColor = 'var(--sg-bg-brand-tertiary-hover, --hover-surface-01)';
  @Output() fileDropped = new EventEmitter<FileList>();

  @HostBinding('style.background')
  private get backgroundColor(): string {
    return this._background;
  }

  @HostBinding('class.drag-active')
  private get isDragActive(): boolean {
    return this._isDragActive;
  }

  private _background = 'inherit';
  private _isDragActive = false;
  private _dragCounter = 0; // Fix for nested elements

  @HostListener('dragenter', ['$event'])
  onDragEnter(event: DragEvent): void {
    this.preventDefaultAndStopPropagation(event);
    this._dragCounter++;
    this._setDragState(true);
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent): void {
    this.preventDefaultAndStopPropagation(event);
    // Ensure drop effect is set for better UX
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent): void {
    this.preventDefaultAndStopPropagation(event);
    this._dragCounter--;

    // Only deactivate when leaving the main element
    if (this._dragCounter === 0) {
      this._setDragState(false);
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    this.preventDefaultAndStopPropagation(event);
    this._dragCounter = 0;
    this._setDragState(false);

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.fileDropped.emit(files);
    }
  }

  private _setDragState(active: boolean): void {
    this._isDragActive = active;
    this._background = active ? this.activeColor : this.initialBackground;
  }

  private preventDefaultAndStopPropagation(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
